
import Grade from "./Grade.vue";
import type { GradeData } from "../models";

export default {
  props: {
    grades: Object as () => GradeData[]
  },
  components: {
    Grade
  },
  methods: {
    arraySum(arr: string[]) {
      return arr.reduce((a: any, b: any) => {
        return parseFloat(a) + parseFloat(b)
      }, 0);
    }
  }
}
